import { render } from "./SliderRound.vue?vue&type=template&id=f1156ed0&scoped=true"
import script from "./SliderRound.vue?vue&type=script&lang=js"
export * from "./SliderRound.vue?vue&type=script&lang=js"

import "./SliderRound.vue?vue&type=style&index=0&id=f1156ed0&scoped=true&lang=css"

import exportComponent from "/Users/SQB/Projects/configurator-project/configurator/webapp/src/main/vue-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1156ed0"]])

export default __exports__